<template>
  <!-- <client-only> -->
  <section
    class="container2"
    :style="{
      '--image-height': data?.height_desktop || '600px',
      '--mobile-image-height': data?.height_mobile || '400px',
    }"
  >
    <Swiper
      :pagination="{
        clickable: true,
      }"
      :autoplay="sliderAutoplay"
      :modules="modules"
      :slides-per-view="1"
      :space-between="5"
      class="h-auto"
      :class="pageClass"
    >
      <SwiperSlide v-for="item in data?.slides" :key="item.id">
        <!-- <NuxtLink
          class="flex h-full flex-col"
          :class="{ 'flex-col-reverse': data.bottomMobile }"
          :to="item?.buttonUrl"
        > -->
        <div
          class="flex h-full flex-col"
          :class="{ 'flex-col-reverse': data.bottomMobile }"
          @click="onClick(item?.buttonUrl)"
        >
          <div
            class="cursor-pointer bg-[var(--background-color-mobile)] lg:h-dynamic-image lg:bg-[var(--background-color)]"
            :class="[
              data.overlayForMobile
                ? data?.height_mobile
                  ? 'h-dynamic-image-mobile'
                  : 'h-[625px]'
                : 'relative h-dynamic-image-mobile',
            ]"
            :style="{
              '--background-color': getBackgroundColor(item.backgroundColor),
              '--background-color-mobile': getBackgroundColor(
                item.backgroundColorMobile || item.backgroundColor,
              ),
              filter: getBrightnessFilter(item),
            }"
          >
            <UiVideo
              v-if="item?.file?.media_type?.includes(assetsTypes.video)"
              class="h-full w-full object-cover"
              :src="item?.file?.url"
              :src-mobile="item?.fileMobile?.url"
              autoplay
              loop
              muted
              playsinline
            />
            <UiLazyImg
              v-else
              class="h-full w-full"
              :class="[
                data.overlayForMobile
                  ? ''
                  : 'max-lg:absolute max-lg:inset-0 max-lg:z-[-1]',
              ]"
              :src="item?.file?.url || ''"
              :src-mobile="item?.fileMobile?.url || ''"
              :alt="
                item?.file?.alt ||
                item.title ||
                removeHTMLTagFromString(item.text) ||
                'Image'
              "
              cover
              :no-lazy="!blockIndex"
            />
            <div
              v-if="!data.overlayForMobile"
              class="min-h-dynamic-image-mobile w-full lg:hidden"
            >
              <div
                class="container flex h-full min-h-dynamic-image-mobile items-center justify-end justify-center py-4"
              >
                <div class="w-full" @click="contentLink" v-html="item.title" />
              </div>
            </div>
          </div>
          <div class="w-full">
            <div
              class="flex items-center justify-center py-4 max-lg:container lg:absolute lg:inset-0 lg:h-full lg:pl-[30px] lg:pr-18 lg2:pl-[40px] xl:pl-[50px] 2xl:pl-[60px]"
              :class="[
                data.overlayForMobile
                  ? 'absolute inset-0 h-full'
                  : 'lg:absolute lg:inset-0 lg:h-full',
              ]"
            >
              <div class="w-full" @click="contentLink" v-html="item.text" />
            </div>
          </div>
        </div>
        <!-- </NuxtLink> -->
      </SwiperSlide>
    </Swiper>
  </section>
  <!-- </client-only> -->
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay } from "swiper";
import { BlockSliderContent, BlockSliderSlide, assetsTypes } from "ecom-types";
import "swiper/css/pagination";

const route = useRoute();
const router = useRouter();
const localePath = useLocalePathPolyfill();
const contentLink = useContentLink;
const { lgAndUp } = useAppBreakpoints();
const props = withDefaults(
  defineProps<{
    data: BlockSliderContent;
    blockIndex?: number;
  }>(),
  {
    blockIndex: -1,
  },
);

const modules = [Pagination, Autoplay];

const pageClass = computed(() => {
  const slug = route.path.slice(1)?.split("/")?.join("-") || "home";
  return slug + "-" + props.blockIndex;
});

const sliderAutoplay = computed(() => {
  return {
    delay: 8000,
  };
});

function getBackgroundColor(color: any) {
  if (!color) return undefined;
  return (color as any)?.hexa || (color as unknown as string) || "transparent";
}

function getBrightnessFilter(item: BlockSliderSlide) {
  const brightness = lgAndUp.value
    ? item.imageBrightnessFilterDesktop
    : item.imageBrightnessFilterMobile;

  return brightness ? `brightness(${brightness}%)` : undefined;
}

function onClick(url?: string) {
  if (url) {
    router.push(localePath(url));
  }
}
</script>

<style scoped>
.swiper :deep(.swiper-pagination) {
  @apply absolute bottom-2.5;
}
.swiper :deep(.swiper-pagination-bullet) {
  @apply mx-2 h-2 w-2 border border-transparent !bg-white opacity-100 transition-all lg:!bg-gray-dark;
}
.swiper :deep(.swiper-pagination-bullet.swiper-pagination-bullet-active) {
  @apply relative h-2.5 w-6 !rounded-md;
}

.swiper
  :deep(.swiper-pagination-bullet.swiper-pagination-bullet-active)::after {
  content: "";
  border-radius: 10px;
  display: block;
  width: 30px;
  height: 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  @apply border border-white transition-all lg:border-gray-dark;
}
</style>
